export function getItem(key) {
    return new Promise((resolve, reject) => {
        resolve(localStorage.getItem(key));
    });
};

export function setItem(key, value) {
    return new Promise((resolve, reject) => {
        resolve(localStorage.setItem(key, value));
    });
};

export function removeItem(key) {
    return new Promise((resolve, reject) => {
        resolve(localStorage.removeItem(key));
    });
};

export default {
    getItem,
    setItem,
    removeItem,
};